// extracted by mini-css-extract-plugin
export default {"root":"ErrorFooter_root__Z4-r3","retryButton":"ErrorFooter_retryButton__hN8qb"};